import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { odcUrls } from "../../URL/ApplicationUrls";
import { contentTypeJson } from "../../Utils/httpHeaders";
import Odc from "../Odc";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useDeleteOdc = (odcId: number | string | undefined) => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (odc: Odc) => {
      await axios.delete(`${odcUrls.deleteOdc(odcId).apiUrl}`, {
        headers: contentTypeJson,
        data: odc.Type,
      });
    },
    onSuccess: async () => {
      toast.success(`Deleting the ODC with the Id ${odcId} was successful`);
      navigate(odcUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
